/**
 * These assemblies and components will be embedded
 * at page level. They can embed any other component,
 * in the component map, and in the RTE map.
 *
 * These components will typically be layout components
 * e.g. Two Columns
 */
import { mapValues } from 'lodash';
import RegularAssembliesMap from './component';
import { SafeAssembly } from '../../error-boundaries';

// keep this list in alphabetical order
import { JumpMenuWithContentAssembly } from '../../jump-menu-with-content';
import { TwoColumnGenericBlockAssembly } from '../../two-column-generic-block';
import { TwoColumnTextAndImageBlockAssembly } from '../../two-column-text-and-image-block';

// keep this list in alphabetical order
const map = {
  ContentfulAssemblyJumpMenuWithContent: JumpMenuWithContentAssembly,
  ContentfulComponentTwoColumnGenericBlock: TwoColumnGenericBlockAssembly,
  ContentfulComponentTwoColumnTextAndImageBlock:
    TwoColumnTextAndImageBlockAssembly,
};

export default Object.assign(
  mapValues(map, (component) => SafeAssembly(component)),
  RegularAssembliesMap
);
